export default __webpack_public_path__ + "static/media/Place.edcf12ff.png";